import { CIcon } from '~/icons/types'
export const ciBicycleFrameCrossbar: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M8.597 14.18h1.01a4.458 4.458 0 0 0-1.81-3.12l-.52.86a3.427 3.427 0 0 1 1.32 2.26Zm-3.46 4a3.5 3.5 0 0 1 0-7 3.164 3.164 0 0 1 1.27.25l.53-.87a4.334 4.334 0 0 0-1.8-.38 4.5 4.5 0 1 0 4.47 5h-1.01a3.502 3.502 0 0 1-3.46 3Z',
      class: 'secondary'
    },
    {
      d:
        'm16.407 9.94-.39-1.1-3.59 4.38a1.339 1.339 0 0 0-.63-.16.22.22 0 0 0-.08.01l-1.8-4.13 6.04-.28-.36-.99-6.1.29-.25-.57-1.09-.01.32.72a.69.69 0 0 0-.11.13l-1.43 2.33-.53.87-1.84 2.99a.523.523 0 0 0-.01.5.509.509 0 0 0 .44.26h5.64a1.36 1.36 0 0 0 1.16.65 1.391 1.391 0 0 0 1.39-1.38 1.267 1.267 0 0 0-.09-.47Zm-5.96 4.24h-4.56l1.39-2.26.52-.86 1.15-1.87 1.87 4.28a1.432 1.432 0 0 0-.37.71Z',
      class: 'main'
    },
    {
      d:
        'M18.857 10.18a4.226 4.226 0 0 0-1.24.18l-.55-1.56-.3-.83-.92-2.58c0-.01-.01-.01-.01-.02a.561.561 0 0 0-.1-.15.381.381 0 0 0-.14-.11.338.338 0 0 0-.17-.05l-.08-.01-2.08-.23a.487.487 0 0 0-.55.45.495.495 0 0 0 .44.55l1.86.2.58 1.65.36.99.06.18.39 1.1.29.79v.01a4.497 4.497 0 1 0 2.16-.56Zm0 8a3.494 3.494 0 0 1-1.82-6.48l1.12 3.15a.496.496 0 0 0 .47.33.556.556 0 0 0 .17-.03.501.501 0 0 0 .3-.64l-1.14-3.21a3.368 3.368 0 0 1 .9-.12 3.5 3.5 0 1 1 0 7ZM10.377 6.89a.495.495 0 0 1-.5.5h-.63l-1.09-.01h-.7a.5.5 0 0 1 0-1l2.43.01a.493.493 0 0 1 .49.5Z',
      class: 'secondary'
    }
  ],
  name: 'bicycle-frame-crossbar',
  type: 'solid'
}
